var React = require('react');

function MapMarkerExclamation (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4a24 24 0 0 0 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 336a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm38.24-238.41l-12.8 128A16 16 0 0 1 201.52 240h-19a16 16 0 0 1-15.92-14.41l-12.8-128A16 16 0 0 1 169.68 80h44.64a16 16 0 0 1 15.92 17.59z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M192 272a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm22.32-192h-44.64a16 16 0 0 0-15.92 17.59l12.8 128A16 16 0 0 0 182.48 240h19a16 16 0 0 0 15.92-14.41l12.8-128A16 16 0 0 0 214.32 80z","className":"fa-primary","key":2})]);
}

MapMarkerExclamation.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MapMarkerExclamation;

MapMarkerExclamation.default = MapMarkerExclamation;
